<template>
  <div class="col-6 col-sm-3 m-1 border-dashed border-success"></div>
</template>

<script>
import store from '../store';

export default {
  name: 'CasinoCompareSlot',

  methods: {},
  props: [],
  store,
  watch: {},
};
</script>
